import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import { ActionRecord } from "../ActionRecord";
import { type ActionQueryScope } from "../ActionService";

/**
 * Fetch every action visible in the given scope ("org" for the caller's
 * organization, "actionhub" for actions published to the Action Hub).
 */
export function useActions(scope: ActionQueryScope) {
  const { actionService } = useDomainServices();
  const { currentOrganization } = useAuth();

  return useQuery<ActionRecord[], Error>({
    queryKey: ["actions", scope, currentOrganization?.org_id],
    queryFn({ signal }) {
      if (currentOrganization === null) {
        return Promise.reject(new Error("Requires login"));
      }

      return actionService.listActions(scope, {
        abortSignal: signal,
        orgId: currentOrganization.org_id,
      });
    },
    enabled: currentOrganization !== null,
  });
}
